import React, {FC} from "react";
import cls from "../../shop.module.scss";
import {ICartItemType} from "../../../../types/state";
import Footer from "./Footer";
import Main from "./Main";
import {TranslationsType} from "../../../../types/homePageTypes";
import {quantitiesType} from "../../ShopPageCart";
interface IMobileProps {
    translationsData: TranslationsType;
    item: ICartItemType;
    quantities: quantitiesType[]
    onChangeCallBack: (quantity: number, item: ICartItemType) => void;
    maxQty: number;
    subTotal: string;
    ProductNotAvailableIntl: string
}

const MobileCartItems: FC<IMobileProps> = (
    {
        item,
        translationsData,
        onChangeCallBack,
        maxQty,
        quantities,
        subTotal,
        ProductNotAvailableIntl
    }
) => {
    return (
        <div className={`${cls.mobile_cart_item} ${cls.cart_mobile}`}>
            <Main
                item={item}
                DeleteIntl={translationsData?.Delete}
                onChangeCallBack={onChangeCallBack}
                quantities={quantities}
                maxQty={maxQty}
                ProductNotAvailableIntl={ProductNotAvailableIntl}
            />
            <Footer
                itemId={item.id}
                formattedBaseTotal={subTotal}
                TotalIntl={translationsData?.Total}
                DeleteIntl={translationsData?.Delete}
            />
        </div>
    )
};

export default MobileCartItems